import { render } from "./MenuDrawer.vue?vue&type=template&id=2c5994b4&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"

import "./MenuDrawer.vue?vue&type=style&index=0&id=2c5994b4&scoped=true&lang=scss"

import exportComponent from "D:\\Projets\\2023\\PNB\\GECD\\gecd-police-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5994b4"]])

export default __exports__